import { useEffect, useState } from 'react';

/**
 * Reactive viewport check. Returns true when the viewport is at/below `maxWidth`
 * (default 768px — the app's mobile breakpoint, matching global.css/calendar.css).
 * Updates live on resize/orientation change via matchMedia.
 */
export function useIsMobile(maxWidth = 768) {
  const query = `(max-width: ${maxWidth}px)`;
  const [isMobile, setIsMobile] = useState(
    () => typeof window !== 'undefined' && window.matchMedia(query).matches,
  );

  useEffect(() => {
    if (typeof window === 'undefined') return undefined;
    const mql = window.matchMedia(query);
    const onChange = (e) => setIsMobile(e.matches);
    setIsMobile(mql.matches);
    // addEventListener is the modern API; older Safari needs addListener.
    if (mql.addEventListener) mql.addEventListener('change', onChange);
    else mql.addListener(onChange);
    return () => {
      if (mql.removeEventListener) mql.removeEventListener('change', onChange);
      else mql.removeListener(onChange);
    };
  }, [query]);

  return isMobile;
}

export default useIsMobile;
